/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Next_Task_LabelInputs */

const en_task_next_task_label = /** @type {(inputs: Task_Next_Task_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next activity`)
};

const pt_br2_task_next_task_label = /** @type {(inputs: Task_Next_Task_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima atividade`)
};

/**
* | output |
* | --- |
* | "Next activity" |
*
* @param {Task_Next_Task_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_next_task_label = /** @type {((inputs?: Task_Next_Task_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Next_Task_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_next_task_label(inputs)
	return pt_br2_task_next_task_label(inputs)
});